module.exports = __webpack_public_path__ + "img/picture_02_portada.cd1542eb.png";